module.exports = __webpack_public_path__ + "static/media/yushan3.c03cf0e6.webp";